// src/services/userRoleService.js

import apiClient from "./apiClient";

const API_URL = `/tokens`; // Use relative path since apiClient has baseURL

export const getAllTokens = async () => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/all`);
  return response.data;
};

export default getAllTokens;